import { useCallback } from 'react'
import { DrawerEvent, DrawerEventType, OpenDrawerEvent } from '@typesApp/AppEvent'
import { useOpenDrawer } from './useOpenDrawer'
import { useEnvironment } from './useEnvironment'

export const useAppDrawerEventListener = (): EventListenerOrEventListenerObject => {
  const { openDrawer } = useOpenDrawer()
  const { basePath } = useEnvironment()

  const handleOpenDrawer = (event: OpenDrawerEvent) => {
    openDrawer(event.payload)
  }

  const eventHandlers = {
    onOpenDrawer: event => event.type === 'onOpenDrawer' && handleOpenDrawer(event),
  } as Record<DrawerEventType, (event: DrawerEvent) => void>

  const eventListener = useCallback(
    (event: Event) => {
      if (!isCustomEvent(event)) return

      const drawerEvent = event?.detail
      if (drawerEvent?.type) {
        eventHandlers[drawerEvent.type]?.(drawerEvent)
      }
    },
    [basePath, openDrawer]
  )

  return eventListener
}

const isCustomEvent = (event: Event): event is CustomEvent<DrawerEvent> => {
  return event instanceof CustomEvent
}
